import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconDefinition, faSearch } from '@fortawesome/pro-duotone-svg-icons';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';
import { DirectoryColumn } from 'src/app/samwebDescription/samweb/directory/directory-column';

@Component({
   selector: 'samweb-directory-table-header',
   templateUrl: './directory-table-header.component.html',
   styleUrls: ['./directory-table-header.component.scss'],
})
export class DirectoryTableHeaderComponent {
   @Input()
   public directoryColumnInstance: DirectoryColumn;
   @Input()
   public isSearchable: boolean;
   @Input()
   public isDefaultCallColumn: boolean;

   public searchFieldIcon: IconDefinition = faSearch;
   public defaultDial: IconDefinition = WellKnownIconsEnum.DEFAULT_DIAL.icon;

   @Output()
   public columnHeaderSearch = new EventEmitter();

   constructor() {}

   public toggleSearchColumn(event) {
      event.preventDefault();
      event.stopPropagation();
      this.columnHeaderSearch.emit(event);
   }
}
